var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_vm.isNew ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "bottom": "",
            "color": "accent",
            "dark": "",
            "fab": "",
            "fixed": "",
            "right": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-pencil")])], 1) : _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-pencil")])], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm.isNew ? [_vm._v(_vm._s(_vm.title) + " 등록")] : [_vm._v(_vm._s(_vm.title) + " 상세")]], 2), _c('v-card-text', [_c('v-text-field', _vm._b({
    staticClass: "mb-2",
    attrs: {
      "label": "제목"
    },
    model: {
      value: _vm.program.title,
      callback: function callback($$v) {
        _vm.$set(_vm.program, "title", $$v);
      },
      expression: "program.title"
    }
  }, 'v-text-field', _vm.inputProps, false)), _c('program-view-dates', {
    attrs: {
      "isApplicationDates": ""
    },
    model: {
      value: _vm.program,
      callback: function callback($$v) {
        _vm.program = $$v;
      },
      expression: "program"
    }
  }), _c('program-view-dates', {
    model: {
      value: _vm.program,
      callback: function callback($$v) {
        _vm.program = $$v;
      },
      expression: "program"
    }
  }), _c('file-chips-field', _vm._b({
    staticClass: "py-2",
    attrs: {
      "label": "첨부파일"
    },
    model: {
      value: _vm.program.files,
      callback: function callback($$v) {
        _vm.$set(_vm.program, "files", $$v);
      },
      expression: "program.files"
    }
  }, 'file-chips-field', _vm.inputProps, false)), _c('naver-smarteditor', {
    staticClass: "mt-2",
    staticStyle: {
      "max-height": "456px",
      "overflow-y": "auto"
    },
    attrs: {
      "rows": "5"
    },
    model: {
      value: _vm.program.content,
      callback: function callback($$v) {
        _vm.$set(_vm.program, "content", $$v);
      },
      expression: "program.content"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-col', {
    staticClass: "pr-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "grey",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.closeButton))])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.saveButton))])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }